import ProdigySelect from './ProdigySelect';

export default ProdigySelect;
